// Shared AI/trademark disclaimer for the PDP audit and proposal surfaces
// (web footers + proposal PDF). The Terms and Privacy links are rendered by
// each surface; this is the body copy only.
export const AI_DISCLAIMER_BODY =
    "The PDP audit and this strategy utilize The Desire Company's AI and draw on " +
    "publicly available information from the URL you submitted. Scores, findings, " +
    "and pricing estimates are informational, may contain inaccuracies, and are not " +
    "professional advice; final quotes are confirmed by our team. The Desire Company " +
    "is not affiliated with, endorsed by, or sponsored by the brands or retailers " +
    "analyzed. Brand and product names are referenced for identification only; all " +
    "trademarks belong to their respective owners. Use of this tool constitutes " +
    "consent to our ";

export const TERMS_URL = "https://thedesirecompany.com/terms";
export const TERMS_LABEL = "Terms of Service";
export const PRIVACY_URL = "https://thedesirecompany.com/privacy";
export const PRIVACY_LABEL = "Privacy Policy";
